import { createSelector } from 'reselect';
import Utils from 'yoda-core-components/lib/helpers/Utils/Utils';
import { selectFeatureFlags, selectPreferences, selectReqHeaders } from './ContextSelector';
import { rewardsRedesign } from '../common/Constants';

export const DEFAULTS = {};

const isRewardsRedesignEnabled = (featureFlags, preferences, reqHeaders) =>
    Utils.isFeatureEnabled(
        featureFlags,
        preferences,
        reqHeaders,
        // featureflag,          cookieName                      headerName
        'enableRewardsRedesign',
        rewardsRedesign.cookieFlagName,
        rewardsRedesign.headerFlagName
    );

// FF
export const selectRewardsRedesignThrottleFF = createSelector(
    [selectFeatureFlags, selectPreferences, selectReqHeaders],
    isRewardsRedesignEnabled
);
